/**
 * Utility functions for sigma calculations
 */
import { CONFIG } from '../config/config.js';

/**
 * Finds the nearest sigma value to the provided sigma
 */
export const findNearestDataSigma = (sigma) => {
  let closestSigma = CONFIG.sigmaValues[0];
  let minDistance = Math.abs(sigma - closestSigma);
  
  for (let i = 1; i < CONFIG.sigmaValues.length; i++) {
    const distance = Math.abs(sigma - CONFIG.sigmaValues[i]);
    if (distance < minDistance) {
      minDistance = distance;
      closestSigma = CONFIG.sigmaValues[i];
    }
  }
  
  return closestSigma;
};

/**
 * Creates timeline markers for the sigma slider
 */
export const createTimelineMarkers = () => {
  const sigmaSlider = document.getElementById('sigma-slider');
  const timelineMarkersContainer = document.getElementById('timeline-markers');
  
  if (timelineMarkersContainer && CONFIG.sigmaValues.length > 0) {
    // Clear existing markers
    timelineMarkersContainer.innerHTML = '';
    
    // Calculate the total range
    const min = parseInt(sigmaSlider.min, 10);
    const max = parseInt(sigmaSlider.max, 10);
    const range = max - min;
    
    // Generate a marker for odd sigma values only, but exclude 19 to prevent overlap with 20
    CONFIG.sigmaValues.forEach(sigma => {
      // Skip sigma value 19 to prevent overlap with 20, show marker for odd numbers and the last value (20)
      if ((sigma % 2 === 1 && sigma !== 19) || sigma === CONFIG.sigmaValues[CONFIG.sigmaValues.length - 1]) {
        const percentage = ((sigma - min) / range) * 100;
        const marker = document.createElement('span');
        marker.className = 'timeline-mark';
        marker.style.left = percentage + '%';
        marker.textContent = sigma.toString();
        timelineMarkersContainer.appendChild(marker);
      }
    });
  }
};

export default {
  findNearestDataSigma,
  createTimelineMarkers
};